<template>
    <div>
        <img src="../assets/image/news/account_title.png" alt="" class="title_img">
        <div class="qr_wrap mb60">
            <template v-for="(item,index) in qr_list">
                <div :key="index" class="qr_item">
                    <img :src="item.url">
                    <p>{{item.text}}</p>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
    let qr_list = [
        {
            text: '【微信小程序】',
            url: require('../assets/image/news/xcx_qr.jpg')
        },
        {
            text: '【微信服务号】',
            url: require('../assets/image/news/service_qr.jpg')
        },
        {
            text: '【腾讯视频号】',
            url: require('../assets/image/news/tengxun_qr.jpg')
        },
        {
            text: '【小红书】',
            url: require('../assets/image/news/redbook_qr.jpg')
        },
        {
            text: '【抖音】',
            url: require('../assets/image/news/douyin_qr.jpg')
        },
        {
            text: '【快手】',
            url: require('../assets/image/news/kuaishou_qr.jpg')
        }
    ]
    export default {
        name: "account",
        data() {
            return{
                qr_list:qr_list
            }
        }
    }
</script>

<style scoped lang="less">
    /*账号*/
    .qr_wrap{
        width: 100%;
        padding: 30px 40px;
        box-sizing: border-box;
        background-color: #365fdb;
        display: flex;
        justify-content: space-around;
        text-align: center;
        color: #fff;
        .qr_item{
            width: 14%;
            img{
                width: 100%;
                height: 160px;
                padding: 10px;
                box-sizing: border-box;
                background-color: #fff;
                margin-bottom: 16px;
                border-radius: 10px;
            }
        }

    }
</style>
